import M from "moment";
import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleDate from "../../../../modules/SimpleDate";
import Button from "../../../../modules/commons/Button";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import { getValueFromDDL, removeNullFields } from "../../../common/mapper";
import { getTableColumns, TABS } from "../config";
import MutasiPartDetail from "./mutasiPartDetail/mutasiPartDetail";
import MutasiPartFilter from "./mutasiPartFilter";
import SimplePrintTable from "../../../../modules/popup/SimplePrintTable";
import Api from "../../../../Services/Api";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import { contructQueryParam } from "../../../../Services/Utils";
import { ACTIVITY_TYPE } from "../../../common/Constants";

class MutasiPartContent extends Component {
  constructor(props) {
    super(props);
    this.isMutasiKeluarTab = props.tab.name === TABS.mutasiKeluar.name;
    this.state = {
      kodeCabang: {},
      loading: false,
      detailVisible: false,
      id: null,
      filterVisible: false,
      printVisible: false,
      submittedFilterData: {},
      filterData: {
        startDate: null,
        endDate: null,
      },
      periode: {
        startDate: M(new Date()).format("DD-MM-YYYY"),
        endDate: M(new Date()).format("DD-MM-YYYY"),
      },
      pagination: {
        totalData: 1,
        limit: 5,
        page: 1,
      },
      dataTable: [],
      alertVisible: false,
      alertTitle: "",
      warningMessage: "",
      actionType: null,
    };
  }

  formatDate = (val) => {
    if (!val) return null;
    const parsed = M(val, ["DD-MM-YYYY", "YYYY-MM-DD"], true);
    return parsed.isValid() ? parsed.format("DD-MM-YYYY") : null;
  };

  async componentDidMount() {
    console.log(this.props);

    if (this.props.kodeCabang !== null) {
      const start = this.state.periode.startDate;
      const end = this.state.periode.endDate;

      const request = this.isMutasiKeluarTab
        ? {
            ...this.state.filterData,
            sourceCabang: this.props.kodeCabang.value,
            startDate: start,
            endDate: end,
          }
        : {
            ...this.state.filterData,
            targetCabang: this.props.kodeCabang.value,
            startDate: start,
            endDate: end,
          };

      this.triggerLoading();
      await this.reloadCurrentPage(request);
      this.triggerLoading();
    }

    this.setState((prev) => ({
      ...prev,
      submittedFilterData: {
        startDate: this.state.periode.startDate,
        endDate: this.state.periode.endDate,
      },
    }));
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.kodeCabang?.value !== this.props.kodeCabang?.value) {
      if (!this.props.kodeCabang?.value) return;

      const request = this.isMutasiKeluarTab
        ? {
            ...this.state.submittedFilterData,
            sourceCabang: this.props.kodeCabang.value,
          }
        : {
            ...this.state.submittedFilterData,
            targetCabang: this.props.kodeCabang.value,
          };

      this.triggerLoading();

      try {
        await this.fetchData(
          request,
          this.state.pagination.page,
          this.state.pagination.limit,
        );
      } catch (err) {
        console.error("Error saat fetchData cabang:", err);
      }

      this.triggerLoading();
    }

    const pageChanged =
      prevState.pagination.page !== this.state.pagination.page;
    const limitChanged =
      prevState.pagination.limit !== this.state.pagination.limit;

    if (pageChanged) {
      if (!this.props.kodeCabang?.value) return;
      this.triggerLoading();

      try {
        await this.fetchData(
          this.state.submittedFilterData || {},
          this.state.pagination.page,
          this.state.pagination.limit,
        );
      } catch (err) {
        console.error("Error saat fetchData pagination:", err);
      }

      this.triggerLoading();
    }
  }

  reloadCurrentPage = async (extraFilter = {}) => {
    const { page, limit } = this.state.pagination;

    const baseFilter =
      Object.keys(extraFilter).length > 0
        ? extraFilter
        : this.state.submittedFilterData;

    await this.fetchData(baseFilter, page, limit);
  };

  fetchData = async (filter = {}, page = 1, limit = 5) => {
    const baseFilter = Object.keys(filter).length
      ? filter
      : this.state.submittedFilterData?.startDate !== undefined
        ? this.state.submittedFilterData
        : this.state.periode;

    const safeStartDate = baseFilter.startDate
      ? this.formatDate(baseFilter.startDate)
      : null;

    const safeEndDate = baseFilter.endDate
      ? this.formatDate(baseFilter.endDate)
      : null;

    let request;

    if (this.props.tab.name === "mutasiKeluar") {
      request = !R.isNil(baseFilter.status)
        ? {
            ...this.state.filterData,
            ...baseFilter,
            startDate: safeStartDate,
            endDate: safeEndDate,
            status: [baseFilter.status],
          }
        : {
            ...baseFilter,
            startDate: safeStartDate,
            endDate: safeEndDate,
          };
    } else {
      request = {
        ...this.state.filterData,
        ...baseFilter,
        startDate: safeStartDate,
        endDate: safeEndDate,
      };
    }

    const response = await this.props.tab.getAll({
      ...request,
      page,
      limit,
    });

    if (response.ok && response.data) {
      const safeData = Array.isArray(response.data.data)
        ? response.data.data
        : [];

      const safeTotal =
        typeof response.data.totalData === "number"
          ? response.data.totalData
          : safeData.length;

      this.setState((prev) => ({
        ...prev,
        pagination: { ...prev.pagination, totalData: safeTotal },
        dataTable: safeData,
      }));
    } else {
      this.setState((prev) => ({
        ...prev,
        pagination: { ...prev.pagination, totalData: 0 },
        dataTable: [],
      }));
    }
  };

  triggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handleValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      periode: {
        ...prevValue.periode,
        [name]: value,
      },
    }));
  };

  handleFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  handleFilterValueChange = (name, value) => {
    console.log(name, value);

    if (!R.equals(name, "endDate") && !R.equals(name, "startDate")) {
      this.setState((prevValue) => ({
        ...prevValue,
        filterData: {
          ...prevValue.filterData,
          [name]: value,
        },
      }));
      return;
    }

    if (
      R.equals(name, "endDate") &&
      M(value).isBefore(this.state.filterData.startDate)
    ) {
      this.setState((prevValue) => ({
        ...prevValue,
        filterData: {
          ...prevValue.filterData,
          startDate: value,
          endDate: value,
        },
      }));
      return;
    }

    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleDetailVisibility = async (index, tambah = false, buttonType = null) => {
    if (tambah) {
      this.setState((prevValue) => ({
        ...prevValue,
        // id: null,
        detailVisible: true,
        buttonType: buttonType,
      }));
    } else if (index || index === 0) {
      this.setState((prevValue) => ({
        ...prevValue,
        id: this.state.dataTable[index].id,
        detailVisible: true,
        buttonType: buttonType,
      }));
    } else {
      this.setState((prevValue) => ({
        ...prevValue,
        id: null,
        detailVisible: false,
        buttonType: buttonType,
      }));
    }
  };

  handleResetFilter = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        startDate: this.state.periode.startDate,
        endDate: this.state.periode.endDate,
      },
    }));
  };

  handleSubmitFilter = async (e) => {
    e.preventDefault();

    this.setState((prev) => ({ ...prev, loading: true }));

    const start = this.state.filterData.startDate
      ? this.formatDate(this.state.filterData.startDate)
      : null;

    const end = this.state.filterData.endDate
      ? this.formatDate(this.state.filterData.endDate)
      : null;

    const request = removeNullFields({
      ...this.state.filterData,
      ...this.getAllDDLValue(this.state.filterData),
      sourceCabang:
        this.state.filterData.sourceCabang === undefined
          ? this.props.kodeCabang?.value
          : this.state.filterData.sourceCabang?.value,
      startDate: start,
      endDate: end,
      statusSource: this.state.filterData.statusSource?.value,
      statusTarget: this.state.filterData.statusTarget?.value,
    });

    try {
      await this.fetchData(request, 1, this.state.pagination.limit);

      this.setState((prev) => ({
        ...prev,
        pagination: {
          ...prev.pagination,
          page: 1,
        },
        submittedFilterData: request,
        filterVisible: false,
      }));
    } finally {
      this.setState((prev) => ({ ...prev, loading: false }));
    }
  };

  handleChangePage = (tableState) => {
    const newPage = tableState.page + 1;

    this.setState((prev) => ({
      ...prev,
      pagination: {
        ...prev.pagination,
        page: newPage,
      },
    }));
  };

  handleRowsPerPage = async (tableState) => {
    const newLimit = tableState.rowsPerPage;

    this.setState(
      (prev) => ({
        ...prev,
        pagination: {
          ...prev.pagination,
          page: 1,
          limit: newLimit,
        },
      }),
      async () => {
        if (!this.props.kodeCabang?.value) return;
        this.triggerLoading();
        await this.fetchData(this.state.submittedFilterData || {}, 1, newLimit);
        this.triggerLoading();
      },
    );
  };

  handlePeriodeChange = (name, value) => {
    if (
      R.equals(name, "endDate") &&
      M(value).isBefore(this.state.periode.startDate)
    ) {
      this.setState((prevValue) => ({
        ...prevValue,
        periode: {
          endDate: value,
          startDate: value,
        },
      }));
      return;
    }

    this.setState((prevValue) => ({
      ...prevValue,
      periode: {
        ...prevValue.periode,
        [name]: value,
      },
    }));
  };

  handlePrint = async () => {
    try {
      this.triggerLoading();

      const baseFilter =
        Object.keys(this.state.submittedFilterData).length > 0
          ? this.state.submittedFilterData
          : this.state.periode;

      const start = baseFilter.startDate
        ? this.formatDate(baseFilter.startDate)
        : null;

      const end = baseFilter.endDate
        ? this.formatDate(baseFilter.endDate)
        : null;

      const cabangKey = this.isMutasiKeluarTab
        ? "sourceCabang"
        : "targetCabang";

      const requestBody = {
        ...baseFilter,
        startDate: start,
        endDate: end,
        [cabangKey]: this.props.kodeCabang?.value,
        page: this.state.pagination.page,
        limit: this.state.pagination.limit,
      };

      const res = await Api.create(
        "NAGAMAS_TRANSACTION_FILE",
      ).generatePrintExcelMutationPart(removeNullFields(requestBody));

      if (res.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = this.isMutasiKeluarTab
          ? "MUTASI_PART_KELUAR.xlsx"
          : "MUTASI_PART_MASUK.xlsx";
        document.body.appendChild(a);
        a.click();

        window.URL.revokeObjectURL(url);
        a.remove();
      } else {
        this.handleAlertModalVisibility("Gagal generate file mutasi part");
      }
    } catch (error) {
      console.error("Error generate print excel:", error);
      this.handleAlertModalVisibility(
        "Terjadi kesalahan saat generate laporan",
      );
    } finally {
      this.triggerLoading();
    }
  };

  handleSearch = async () => {
    if (!this.props.kodeCabang || !this.props.kodeCabang.value) {
      console.warn("Kode cabang belum dipilih!");
      return;
    }

    this.setState((prev) => ({ ...prev, filterData: {}, loading: true }));

    const start = this.formatDate(this.state.periode.startDate);
    const end = this.formatDate(this.state.periode.endDate);

    const request = this.isMutasiKeluarTab
      ? { sourceCabang: this.props.kodeCabang.value }
      : { targetCabang: this.props.kodeCabang.value };

    await this.fetchData(
      { ...request, startDate: start, endDate: end },
      this.state.pagination.page,
      this.state.pagination.limit,
    );

    this.setState((prev) => ({
      ...prev,
      submittedFilterData: { ...request, startDate: start, endDate: end },
      loading: false,
    }));
  };

  getAllDDLValue = (data) => {
    if (!R.isNil(data)) {
      return {
        sourceCabang: getValueFromDDL(data, "sourceCabang"),
        sourceLocator: getValueFromDDL(data, "sourceLocator"),
        targetCabang: getValueFromDDL(data, "targetCabang"),
        targetLocator: getValueFromDDL(data, "targetLocator"),
        status: getValueFromDDL(data, "status"),
        variantCode: getValueFromDDL(data, "variantCode"),
        kodeKsu: getValueFromDDL(data, "kodeKsu"),
        kodeHadiah: getValueFromDDL(data, "kodeHadiah"),
        kodePart: getValueFromDDL(data, "kodePart"),
      };
    }

    return {};
  };

  handleRejectAll = async (data) => {
    this.triggerLoading();
    Api.create("NAGAMAS_TRANSACTION").rejectAllMutationPart(data.id);

    const start = this.formatDate(this.state.filterData.startDate);
    const end = this.formatDate(this.state.filterData.endDate);

    const request = this.isMutasiKeluarTab
      ? {
          ...this.state.filterData,
          sourceCabang: this.props.kodeCabang.value,
          startDate: start,
          endDate: end,
        }
      : {
          ...this.state.filterData,
          targetCabang: this.props.kodeCabang.value,
          startDate: start,
          endDate: end,
        };

    await this.reloadCurrentPage(request);
    await this.handleDetailVisibility();
    this.handleAlertModalVisibility(
      "Data mutasi part masuk telah ditolak",
      "Proses Data Mutasi",
    );
    this.triggerLoading();
  };

  handleAlertModalVisibility = (text, title) => {
    this.setState((prevState) => ({
      ...prevState,
      alertVisible: !prevState.alertVisible,
      alertTitle: title || "",
      warningMessage: text || "",
    }));
  };

  handleRefresh = async () => {
    this.setState((prev) => ({ ...prev, loading: true }));

    try {
      const today = M().format("DD-MM-YYYY");

      const updatedPeriode = {
        startDate: today,
        endDate: today,
      };

      const request = this.isMutasiKeluarTab
        ? {
            ...this.state.submittedFilterData,
            sourceCabang: this.props.kodeCabang?.value,
            ...updatedPeriode,
          }
        : {
            ...this.state.submittedFilterData,
            targetCabang: this.props.kodeCabang?.value,
            ...updatedPeriode,
          };

      await this.fetchData(
        request,
        this.state.pagination.page,
        this.state.pagination.limit,
      );

      this.setState((prev) => ({
        ...prev,
        periode: updatedPeriode,
        submittedFilterData: request,
      }));

      this.handleAlertModalVisibility("Data berhasil diproses", "Information");
    } catch (error) {
      console.error("Error saat refresh:", error);
      this.handleAlertModalVisibility("Gagal memuat data ulang", "Error");
    } finally {
      this.setState((prev) => ({ ...prev, loading: false }));
    }
  };

  render() {
    const tableColumns = [
      ...getTableColumns(this.isMutasiKeluarTab, this.state.pagination),
      {
        name: this.isMutasiKeluarTab ? "status" : "receivedStatus",
        label: "Aksi",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            const canEdit = this.isMutasiKeluarTab
              ? val === "REJECTED_APPROVAL"
              : val === "PROCESSED";

            const allowedDeleteStatus = [
              "REJECTED_APPROVAL",
              "RECEIVED",
              "REJECTED",
              "PARTIALLY_RECEIVED",
            ];

            const canDelete = this.isMutasiKeluarTab
              ? allowedDeleteStatus.includes(val)
              : false;

            return (
              <FlexView style={{ gap: "10px" }}>
                <Button
                  className="btnAct"
                  onClick={() =>
                    this.handleDetailVisibility(rowIndex, false, "preview")
                  }
                >
                  <i
                    className="fa fa-lg fa-eye"
                    style={{ fontSize: 20, color: "red" }}
                  />
                </Button>

                <Button
                  disabled={!canEdit}
                  className="btnAct"
                  onClick={() => this.handleDetailVisibility(rowIndex)}
                >
                  <i
                    className={
                      this.isMutasiKeluarTab
                        ? "fa fa-lw fa-pencil-alt"
                        : "fa fa-lw fa-sync"
                    }
                    style={{ fontSize: 20, color: canEdit ? "red" : "gray" }}
                  />
                </Button>

                {this.isMutasiKeluarTab && (
                  <Button
                    className="btnAct"
                    onClick={() =>
                      this.handleDetailVisibility(rowIndex, false, "delete")
                    }
                  >
                    <i
                      className="fa fa-lw fa-trash"
                      style={{ fontSize: 20, color: "red" }}
                    />
                  </Button>
                )}
              </FlexView>
            );
          },
          sort: false,
        },
      },
    ];
    return (
      <>
        <FlexView
          style={{ justifyContent: "space-between" }}
          vAlignContent="center"
          className="margin-top-5px"
        >
          <FlexView vAlignContent="center" style={{ gap: "10px" }}>
            <p className="margin-bottom-20px">Periode: </p>
            <SimpleDate
              id="select_date_period_from"
              name="startDate"
              nextdate
              date={this.state.periode.startDate}
              maxDate={this.state.periode.endDate}
              onChange={(value) => this.handlePeriodeChange("startDate", value)}
            />
            <span className="margin-bottom-20px">s/d</span>
            <SimpleDate
              id="select_date_period_to"
              name="endDate"
              nextdate
              date={this.state.periode.endDate}
              onChange={(value) => this.handlePeriodeChange("endDate", value)}
            />
            <SimpleButton
              className="margin-bottom-20px"
              onClick={this.handleSearch}
            >
              Cari
            </SimpleButton>
          </FlexView>
          <Button
            type="button"
            onClick={this.handleFilterVisibility}
            className="btn background-red margin-bottom-20px"
          >
            <span>
              <i className="fa fa-sliders-h"></i>
            </span>
          </Button>
        </FlexView>
        <SimpleDataTable
          key={`${this.state.pagination.page}-${this.state.pagination.limit}`}
          data={this.state.dataTable}
          columns={tableColumns}
          toCount={this.state.pagination.totalData}
          rowsPerPage={this.state.pagination.limit}
          page={this.state.pagination.page - 1}
          options={defaultTableChange(
            this.handleChangePage,
            this.handleRowsPerPage,
          )}
          footerAdditionalButtons={
            <>
              {this.isMutasiKeluarTab && (
                <SimpleButton
                  icon={<i className="fa fa-plus margin-right-10px" />}
                  onClick={() => this.handleDetailVisibility(null, true)}
                >
                  Tambah
                </SimpleButton>
              )}
              <SimpleButton onClick={this.handlePrint}>Cetak</SimpleButton>
            </>
          }
        />
        {this.state.filterVisible && (
          <MutasiPartFilter
            state={this.state}
            mutasiKeluarTab={this.isMutasiKeluarTab}
            onReset={this.handleResetFilter}
            onSubmit={this.handleSubmitFilter}
            onValueChange={this.handleFilterValueChange}
            onClickClose={() => this.handleFilterVisibility()}
          />
        )}
        {this.state.detailVisible && (
          <MutasiPartDetail
            user={this.props.user}
            setError={this.props.setError}
            tab={this.props.tab}
            mutasiKeluarTab={this.isMutasiKeluarTab}
            state={this.state}
            cabangData={this.props.cabangData}
            handleRejectAll={this.handleRejectAll}
            kodeCabang={this.props.kodeCabang}
            onRefresh={() => this.handleRefresh()}
            onClickClose={() => this.handleDetailVisibility()}
          />
        )}
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
        {this.state.printVisible && (
          <SimplePrintTable onClearPrint={this.handlePrint} />
        )}
        {this.state.alertVisible && (
          <SimpleAlert
            title={this.state.alertTitle || "Information"}
            content={
              <div>
                <p>{this.state.warningMessage}</p>
              </div>
            }
            visible={this.state.alertVisible}
            onClickClose={this.handleAlertModalVisibility}
            additionalButtons={
              <>
                <SimpleButton
                  type="button"
                  text="OK"
                  onClick={() => this.handleAlertModalVisibility()}
                />
              </>
            }
          />
        )}
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
      </>
    );
  }
}

export default MutasiPartContent;
